// extracted by mini-css-extract-plugin
export var deleteIcon = "_rc-5";
export var deleteOption = "_rc-3";
export var divider = "_rc-2";
export var downloadIcon = "_rc-4";
export var drawer = "_rc-0";
export var drawerFooter = "_rc-6";
export var drawerOpen = "_rc-1";
export var highlighted = "_rc-7";
export var lighterHighlight = "_rc-8";